import { render, staticRenderFns } from "./Orderbatch.vue?vue&type=template&id=e64430fe&scoped=true"
import script from "./Orderbatch.vue?vue&type=script&lang=js"
export * from "./Orderbatch.vue?vue&type=script&lang=js"
import style0 from "./Orderbatch.vue?vue&type=style&index=0&id=e64430fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64430fe",
  null
  
)

export default component.exports